/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkDeleteProductsDto } from '../models/BulkDeleteProductsDto';
import type { CreateProductDto } from '../models/CreateProductDto';
import type { Product } from '../models/Product';
import type { ProductDefaultsBatchRequestDto } from '../models/ProductDefaultsBatchRequestDto';
import type { ProductDefaultsBatchResponseDto } from '../models/ProductDefaultsBatchResponseDto';
import type { UpdateProductDto } from '../models/UpdateProductDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductsService {
  /**
   * Create a new product
   * @param requestBody
   * @returns Product Product created successfully
   * @throws ApiError
   */
  public static productsControllerCreate(
    requestBody: CreateProductDto,
  ): CancelablePromise<Product> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/products',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        409: `Product code already exists`,
      },
    });
  }
  /**
   * Get all products
   * @param page Page number
   * @param limit Items per page
   * @param searchName Search by name
   * @param searchCode Search by code
   * @param searchTerm Search by both name and code
   * @param categoryId Filter by category
   * @param status Filter by status
   * @param supplierId Filter by supplier
   * @param minWeight Minimum weight in grams
   * @param maxWeight Maximum weight in grams
   * @param searchTag Search by tag name
   * @param materialId Filter by material ID
   * @param diameterSize Filtro por talla — coincidencia exacta (diameterSize)
   * @param color Filter by color (partial match)
   * @param workshopCode Filter by workshop code (partial match)
   * @param sortBy Sort column whitelist: updatedAt, createdAt, code, name, salePrice, status, weightGrams, categoryName, supplierName
   * @param sortOrder ASC or DESC (default DESC)
   * @returns any Products retrieved successfully
   * @throws ApiError
   */
  public static productsControllerFindAll(
    page?: number,
    limit?: number,
    searchName?: string,
    searchCode?: string,
    searchTerm?: string,
    categoryId?: number,
    status?: 'ACTIVE' | 'INACTIVE',
    supplierId?: number,
    minWeight?: number,
    maxWeight?: number,
    searchTag?: string,
    materialId?: number,
    diameterSize?: string,
    color?: string,
    workshopCode?: string,
    sortBy?: string,
    sortOrder?: 'ASC' | 'DESC',
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/products',
      query: {
        page: page,
        limit: limit,
        searchName: searchName,
        searchCode: searchCode,
        searchTerm: searchTerm,
        categoryId: categoryId,
        status: status,
        supplierId: supplierId,
        minWeight: minWeight,
        maxWeight: maxWeight,
        searchTag: searchTag,
        materialId: materialId,
        diameterSize: diameterSize,
        color: color,
        workshopCode: workshopCode,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
    });
  }
  /**
   * Get product defaults in batch for inventory assignment
   * @param requestBody
   * @returns ProductDefaultsBatchResponseDto Product defaults retrieved successfully
   * @throws ApiError
   */
  public static productsControllerGetDefaultsBatch(
    requestBody: ProductDefaultsBatchRequestDto,
  ): CancelablePromise<ProductDefaultsBatchResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/products/defaults/batch',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get a product by ID
   * @param id Product ID
   * @returns Product Product retrieved successfully
   * @throws ApiError
   */
  public static productsControllerFindOne(id: number): CancelablePromise<Product> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/products/{id}',
      path: {
        id: id,
      },
      errors: {
        404: `Product not found`,
      },
    });
  }
  /**
   * Update a product
   * @param id Product ID
   * @param requestBody
   * @returns Product Product updated successfully
   * @throws ApiError
   */
  public static productsControllerUpdate(
    id: number,
    requestBody: UpdateProductDto,
  ): CancelablePromise<Product> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/products/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        404: `Product not found`,
        409: `Product code already exists`,
      },
    });
  }
  /**
   * Delete a product
   * @param id Product ID
   * @returns any Product deleted successfully
   * @throws ApiError
   */
  public static productsControllerRemove(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/products/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Cannot delete product due to dependencies`,
        404: `Product not found`,
      },
    });
  }
  /**
   * Delete multiple products
   * @param requestBody
   * @returns any Bulk delete completed
   * @throws ApiError
   */
  public static productsControllerBulkRemove(
    requestBody: BulkDeleteProductsDto,
  ): CancelablePromise<{
    success?: boolean;
    deletedCount?: number;
    errors?: Array<{
      productId?: number;
      reason?: string;
      errorCode?: number;
      /**
       * Count of associated entities (only for ProductDeletionException errors)
       */
      countAssociates?: Array<number>;
      /**
       * Types of associations (only for ProductDeletionException errors)
       */
      associationTypes?: Array<string>;
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/products/bulk-delete',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
      },
    });
  }
  /**
   * Export all products to CSV
   * @returns binary CSV file with all products
   * @throws ApiError
   */
  public static productsControllerExportToCsv(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/products/export/csv',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
